import src from '../../assets/coins/zec.webp';

type Props = {
  size?: number;
  className?: string;
};

export function ZecIcon({ size = 44, className }: Props) {
  return (
    <img
      src={src}
      alt=""
      aria-label="ZEC"
      width={size}
      height={size}
      draggable={false}
      className={`shrink-0 rounded-full object-cover ${className ?? ''}`}
      style={{ width: size, height: size }}
    />
  );
}
